var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.5C1 1.67157 1.67157 1 2.5 1H9.5C10.3284 1 11 1.67157 11 2.5V4.43863C10.5974 4.76102 10.3309 5.23053 10.2656 5.74998H6.75C5.50736 5.74998 4.5 6.75733 4.5 7.99998C4.5 9.24262 5.50736 10.25 6.75 10.25H10.2656C10.3309 10.7694 10.5973 11.239 11 11.5614V13.5C11 14.3284 10.3284 15 9.5 15H2.5C1.67157 15 1 14.3284 1 13.5V2.5ZM11.9627 5.30643C11.6824 5.42252 11.4997 5.696 11.4997 5.99934V6.99934H6.74966C6.19738 6.99934 5.74966 7.44706 5.74966 7.99934C5.74966 8.55163 6.19738 8.99934 6.74966 8.99934H11.4997V9.99934C11.4997 10.3027 11.6824 10.5762 11.9627 10.6923C12.2429 10.8083 12.5655 10.7442 12.78 10.5297L14.78 8.52967C15.0729 8.23678 15.0729 7.7619 14.78 7.46901L12.78 5.46901C12.5655 5.25451 12.2429 5.19035 11.9627 5.30643Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.7025186d6e89f51206153ecc9ba90890.svg";
export { ForwardRef as ReactComponent };